import { render, staticRenderFns } from "./config.vue?vue&type=template&id=b34af456"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b34af456')) {
      api.createRecord('b34af456', component.options)
    } else {
      api.reload('b34af456', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=b34af456", function () {
      api.rerender('b34af456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/2-1-catalog-list-1/config.vue"
export default component.exports